module.exports = __webpack_public_path__ + "static/user-testing-2-a90b4adf0bbbe72c1436231bd3baea55.jpg";